import { CheckCircle2 } from 'lucide-react';

export const Eyebrow = ({ children, tone = 'orange' }) => (
  <span className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-[0.2em] border ${
    tone === 'blue' ? 'border-blue-400/40 text-blue-300 bg-blue-500/10' : 'border-orange-400/40 text-orange-300 bg-orange-500/10'}`}>
    {children}
  </span>
);

export const CheckList = ({ items, tone = 'orange' }) => (
  <ul className="space-y-3">
    {items.map((t) => (
      <li key={t} className="flex items-start gap-3 text-slate-300">
        <CheckCircle2 className={`w-5 h-5 mt-0.5 shrink-0 ${tone === 'blue' ? 'text-blue-400' : 'text-orange-400'}`} />
        <span>{t}</span>
      </li>
    ))}
  </ul>
);

export const PageHero = ({ eyebrow, tone, title, accent, intro, image, imageAlt, aside, children, testid, frame }) => (
  <section data-testid={testid} className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 md:pt-24 pb-16 grid lg:grid-cols-12 gap-12 items-center">
    <div className="lg:col-span-7 space-y-7">
      <div className="rise-in"><Eyebrow tone={tone}>{eyebrow}</Eyebrow></div>
      <h1 className="rise-in font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight" style={{ animationDelay: '80ms' }}>
        {title} {accent && <span className={tone === 'blue' ? 'text-blue-400' : 'text-orange-400'}>{accent}</span>}
      </h1>
      <p className="rise-in text-base md:text-lg text-slate-300 leading-relaxed max-w-2xl" style={{ animationDelay: '160ms' }}>{intro}</p>
      <div className="rise-in" style={{ animationDelay: '240ms' }}>{children}</div>
    </div>
    <div className="lg:col-span-5 relative rise-in" style={{ animationDelay: '200ms' }}>
      <div data-testid={`${testid}-image-frame`} className={`absolute -inset-3 rounded-[2rem] ${
        frame === 'white' ? 'bg-white shadow-2xl' : `rotate-2 ${tone === 'blue' ? 'bg-blue-600/20' : 'bg-orange-500/15'}`}`} />
      <img src={image} alt={imageAlt} className={`relative w-full h-[440px] object-cover shadow-2xl no-zoom ${frame === 'white' ? 'rounded-[20px]' : 'rounded-[2rem]'}`} />
      {aside && <div className="absolute -bottom-8 -left-6 z-10">{aside}</div>}
    </div>
  </section>
);

export const SectionTitle = ({ kicker, title, sub }) => (
  <div className="max-w-3xl mb-12">
    {kicker && <p className="text-xs uppercase tracking-[0.3em] text-orange-400 font-semibold mb-3">{kicker}</p>}
    <h2 className="font-display text-3xl md:text-4xl font-bold text-white tracking-tight mb-3">{title}</h2>
    {sub && <p className="text-base md:text-lg text-slate-400">{sub}</p>}
  </div>
);
